module.exports = __webpack_public_path__ + "img/shopee_9thb_0012.66d86d29.png";